<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      liked?: boolean
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 15,
      height: 15,
      color: 'currentColor',
      viewBoxValue: `0 0 15 15`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      v-if="liked"
      d="M7.5 2.95474C6.74371 2.30456 5.75254 1.96313 4.73758 2.00316C3.72262 2.04319 2.76405 2.46153 2.06602 3.16907C1.36799 3.87662 0.985647 4.81747 1.00041 5.79126C1.01518 6.76506 1.42588 7.69486 2.14507 8.38265L6.58142 12.6353C6.82507 12.8688 7.15548 13 7.5 13C7.84452 13 8.17493 12.8688 8.41858 12.6353L12.8549 8.38265C13.5741 7.69486 13.9848 6.76506 13.9996 5.79126C14.0144 4.81747 13.632 3.87662 12.934 3.16907C12.2359 2.46153 11.2774 2.04319 10.2624 2.00316C9.24746 1.96313 8.25629 2.30456 7.5 2.95474Z"
      fill="currentColor"
    />
    <path
      v-else
      d="M7.5 2.95474C6.74371 2.30456 5.75254 1.96313 4.73758 2.00316C3.72262 2.04319 2.76405 2.46153 2.06602 3.16907C1.36799 3.87662 0.985647 4.81747 1.00041 5.79126C1.01518 6.76506 1.42588 7.69486 2.14507 8.38265L6.58142 12.6353C6.82507 12.8688 7.15548 13 7.5 13C7.84452 13 8.17493 12.8688 8.41858 12.6353L12.8549 8.38265C13.5741 7.69486 13.9848 6.76506 13.9996 5.79126C14.0144 4.81747 13.632 3.87662 12.934 3.16907C12.2359 2.46153 11.2774 2.04319 10.2624 2.00316C9.24746 1.96313 8.25629 2.30456 7.5 2.95474ZM6.73863 3.97866L7.04071 4.26765C7.16253 4.38441 7.32774 4.45001 7.5 4.45001C7.67226 4.45001 7.83747 4.38441 7.95929 4.26765L8.26137 3.97866C8.50108 3.74072 8.78781 3.55093 9.10484 3.42036C9.42187 3.28979 9.76285 3.22107 10.1079 3.21819C10.4529 3.21532 10.7951 3.27835 11.1144 3.40362C11.4338 3.52888 11.7239 3.71387 11.9679 3.94778C12.2119 4.1817 12.4048 4.45986 12.5355 4.76603C12.6662 5.0722 12.7319 5.40025 12.7289 5.73104C12.7259 6.06184 12.6542 6.38874 12.518 6.69269C12.3818 6.99664 12.1839 7.27154 11.9357 7.50135L7.5 11.7546L3.0643 7.50135C2.59096 7.03149 2.32904 6.40218 2.33496 5.74897C2.34088 5.09576 2.61417 4.47092 3.09596 4.00901C3.57775 3.5471 4.22949 3.2851 4.91082 3.27942C5.59214 3.27374 6.24854 3.52485 6.73863 3.97866Z"
      fill="currentColor"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
